var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAndroidFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 702,
    viewBox: "0 0 502 702",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M438.61 1.04873H138.61C136.97 1.02873 135.345 1.35203 133.838 1.99783C132.331 2.64373 130.976 3.59773 129.86 4.79873L4.85976 129.799C3.65876 130.915 2.70475 132.27 2.05875 133.777C1.41275 135.284 1.08976 136.909 1.10976 138.549V638.549C1.10976 655.125 7.69476 671.022 19.4158 682.743C31.1368 694.464 47.0338 701.049 63.6098 701.049H438.61C455.186 701.049 471.083 694.464 482.804 682.743C494.525 671.022 501.11 655.125 501.11 638.549V63.5488C501.11 46.9726 494.525 31.0755 482.804 19.3545C471.083 7.63353 455.186 1.04873 438.61 1.04873Z",
    fill: "url(#paint0_linear_2269_378)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M143.359 1.04767C141.106 0.0265651 138.588 -0.257334 136.164 0.236466C133.74 0.730266 131.533 1.97647 129.859 3.79767L4.85888 128.798C2.64488 130.401 1.05888 132.726 0.373875 135.373C-0.310125 138.02 -0.0501239 140.822 1.10888 143.298C2.10588 145.745 3.85288 147.814 6.09888 149.206C8.34388 150.598 10.9739 151.243 13.6089 151.048H88.6089C96.8169 151.048 104.944 149.431 112.527 146.29C120.11 143.15 127 138.546 132.803 132.742C138.607 126.939 143.211 120.049 146.351 112.466C149.492 104.883 151.109 96.7557 151.109 88.5477V13.5477C151.304 10.9125 150.659 8.28307 149.267 6.03727C147.875 3.79137 145.806 2.04457 143.359 1.04767Z",
    fill: "url(#paint1_linear_2269_378)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2269_378",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 59,
    y: 159,
    width: 385,
    height: 385
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M443.109 159.048H59.1089V543.048H443.109V159.048Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2269_378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M354.264 224.737C362.168 228.689 365.371 238.299 361.419 246.203L342.627 283.789C384.027 312.708 411.109 360.715 411.109 415.048V431.048C411.109 448.72 396.783 463.048 379.109 463.048H123.109C105.436 463.048 91.1089 448.72 91.1089 431.048V415.048C91.1089 360.715 118.19 312.708 159.591 283.789L140.798 246.203C136.846 238.299 140.05 228.689 147.954 224.737C155.857 220.785 165.468 223.988 169.42 231.892L187.557 268.166C207.037 259.726 228.527 255.048 251.109 255.048C273.691 255.048 295.181 259.726 314.661 268.166L332.799 231.892C336.751 223.988 346.36 220.785 354.264 224.737ZM251.109 287.048C180.417 287.048 123.109 344.355 123.109 415.048V431.048H379.109V415.048C379.109 344.355 321.802 287.048 251.109 287.048ZM195.109 351.048C208.364 351.048 219.109 361.792 219.109 375.048C219.109 388.302 208.364 399.048 195.109 399.048C181.854 399.048 171.109 388.302 171.109 375.048C171.109 361.792 181.854 351.048 195.109 351.048ZM307.109 351.048C320.363 351.048 331.109 361.792 331.109 375.048C331.109 388.302 320.363 399.048 307.109 399.048C293.855 399.048 283.109 388.302 283.109 375.048C283.109 361.792 293.855 351.048 307.109 351.048Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2269_378",
    x1: 17.3598,
    y1: 117.299,
    x2: 532.86,
    y2: 632.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#73E4D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BB27D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2269_378",
    x1: 1.10888,
    y1: 76.0477,
    x2: 151.109,
    y2: 76.0477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D2C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52CEB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAndroidFile);
export default __webpack_public_path__ + "static/media/ic-android-file.27a07c7063fc57dfca9a72d0039e7686.svg";
export { ForwardRef as ReactComponent };